import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"variable\":\"--font-geist-sans\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist_Mono\",\"arguments\":[{\"variable\":\"--font-geist-mono\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/AppInsightsProvider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/app/src/app/components/i18n/i18n-providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/app/src/app/context/user-context.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/styles/globals.css");
